module.exports = __webpack_public_path__ + "static/media/git-branch.ecd41aaa.png";